import { render, staticRenderFns } from "./MatchReferralCancellationModal.vue?vue&type=template&id=12c2e935&scoped=true"
import script from "./MatchReferralCancellationModal.vue?vue&type=script&lang=js"
export * from "./MatchReferralCancellationModal.vue?vue&type=script&lang=js"
import style0 from "./MatchReferralCancellationModal.vue?vue&type=style&index=0&id=12c2e935&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c2e935",
  null
  
)

export default component.exports